import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 0, 4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      marginBottom: '60px',
    },
  },
  tabContent: {
    padding: theme.spacing(2, 3, 0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 2, 0),
    },
  },
  groupEventsWrapper: {
    marginTop: 0,
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(8),
    },
  },
  availabilityWarningBox: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    backgroundColor: theme.palette.primary.selected,
    padding: theme.spacing(2),
    maxWidth: '840px',
    marginBottom: theme.spacing(5),
  },
  availabilityWarningText: {
    fontSize: '16px',
    fontWeight: 500,
    paddingRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(0),
    },
  },
  disabledActionTile: {
    backgroundColor: theme.palette.grey[200],
  },
}))
